import { cn } from "@/lib/utils";

interface OnlineIndicatorProps {
  isOnline: boolean;
  size?: "sm" | "md";
  className?: string;
}

export const OnlineIndicator = ({ isOnline, size = "sm", className }: OnlineIndicatorProps) => {
  if (!isOnline) return null;
  return (
    <span
      className={cn(
        "rounded-full bg-emerald-500 ring-2 ring-background block",
        size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3",
        className
      )}
    />
  );
};
